import { ActionSuccessResult, ActionContract, ActionRegistry } from "./registry-contract";
import { ActionImplementation, ActionDisplayLoc, HostedActionContent } from "./implementation-contract";
import { ActionTriggerLink, ActionTriggerOptions, RightRequirement } from "./trigger-contract";
import { UiControlConstants } from "../../../ShellCommon/common/uicontrol-constants";
import { ButtonController } from "../../../ShellCommon/Controls/button/button";
import { SdServicesSharedEnums } from "../sdServices-shared-enums";

interface TriggerAttributeOptions extends ActionTriggerOptions {
  onDisabledChanged?: string;
  onDisabledChangedCallback?: (locals: { isDisabled: boolean }) => void;
}

export const directiveName = "aafActionTrigger";
// @ngInject
export let actionTriggerDirective = (
  actionRegistryService: ActionRegistry,
  $parse: ng.IParseService,
  uiControlConstants: UiControlConstants,
  sdServicesSharedEnums: SdServicesSharedEnums
): ng.IDirective => {
  let linker = function (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
    let options: TriggerAttributeOptions = scope.$eval(attrs[directiveName]);
    if (options.onDisabledChanged) {
      // Inspired by angular's '&' binding
      let parentGet = $parse(options.onDisabledChanged);
      options.onDisabledChangedCallback = function (locals) {
        return parentGet(scope, locals);
      };
    }

    let triggerLink = actionRegistryService.getActionTriggerLink(options, element);

    element.click(() => {
      element.blur();
      triggerLink.invoke();
    });

    let keyNumbers = [uiControlConstants.keyCode.enterKeyCode, uiControlConstants.keyCode.spaceKeyCode];
    element.on("keydown", (event: JQueryEventObject) => {
      if (keyNumbers.indexOf(event.which) >= 0) {
        element.blur();
        triggerLink.invoke();
      }
    });

    // TODO : "Pending" UX treatment is not yet defined.
    let hidePendingTreatment = () => {};
    let showPendingTreatment = () => {};

    scope.$watch(
      () => {
        return triggerLink.getActionEligibility();
      },
      (viewState: any, oldViewState: any) => {
        if (viewState != oldViewState) {
          switch (oldViewState) {
            case sdServicesSharedEnums.actionEligibility.NotAllowed:
              element.removeAttr("disabled");
              if (element[0].tagName.toLowerCase() == "sd-button") {
                let buttonController = <ButtonController>(<any>element.isolateScope())["$ctrl"];
                buttonController.setInternallyDisabled(false);
              }
              if (options.onDisabledChanged) {
                options.onDisabledChangedCallback({ isDisabled: false });
              }
              break;
            case sdServicesSharedEnums.actionEligibility.NotApplicable:
              element.show();
              break;
            case sdServicesSharedEnums.actionEligibility.NotYetKnown:
              hidePendingTreatment();
              break;
          }
        }

        switch (viewState) {
          case sdServicesSharedEnums.actionEligibility.NotAllowed:
            element.attr("disabled", "disabled");
            if (element[0].tagName.toLowerCase() == "sd-button") {
              let buttonController = <ButtonController>(<any>element.isolateScope())["$ctrl"];
              buttonController.setInternallyDisabled(true);
            }
            if (options.onDisabledChanged) {
              options.onDisabledChangedCallback({ isDisabled: true });
            }
            break;
          case sdServicesSharedEnums.actionEligibility.NotApplicable:
            element.hide();
            break;
          case sdServicesSharedEnums.actionEligibility.NotYetKnown:
            showPendingTreatment();
            break;
        }
      }
    );
  };

  return {
    restrict: "A",
    link: linker
  };
};
